module.exports = __webpack_public_path__ + "img/jituanyinying.7bebaf68.png";